"use client";

import Honeybadger from "@/honeybadger.config";
import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Honeybadger.notify(error, {
      context: {
        url: typeof window !== "undefined" ? window.location.href : "unknown",
        pathname:
          typeof window !== "undefined"
            ? window.location.pathname
            : "unknown",
        digest: error.digest ?? "none",
        errorName: error.name,
        componentStack:
          (error as Error & { componentStack?: string }).componentStack ??
          "none",
      },
    });
  }, [error]);

  return (
    <html>
      <body>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            gap: "1rem",
          }}
        >
          <h2>Something went wrong</h2>
          <button onClick={() => reset()}>Try again</button>
        </div>
      </body>
    </html>
  );
}
